import { Effect, Reducer } from 'umi';
import { overviewOriginType } from '../../types/performance';
import { getStoreStats } from '../../services/store';

const namespace = 'opinionStore';

type stateType = {
  [key: string]: any;
};

const customModel: {
  effects: {
    [key: string]: Effect;
  };
  namespace: string;
  state: stateType;
  reducers: {
    save: Reducer<stateType>;
  };
} = {
  namespace,
  state: {},
  reducers: {
    save(state: stateType, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {
    *getStoreStats({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getStoreStats({
          ...payload,
        });

        yield put({
          type: 'save',
          payload: {
            stats: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            stats: [],
          },
        });
      }
    },
  },
};

export default customModel;
